import React, { Component } from "react";
import Slider from "react-slick";
import ProductGalleryImage from './ProductGalleryImage';

export default class ProductGallery extends Component {
	
	constructor(props) {
    	super(props);
    }
    
    state = {
    	slideIndex: 0,
		updateCount: 0
  	}
  	
	componentDidMount() {
		setTimeout(() => {
			if (document.getElementsByClassName('slick-cover').length > 0) {
				document.getElementsByClassName('slick-cover')[0].classList.add('state-inactive');
			}
		}, 2000);
	}
  			
	render() {
		if (this.props.item.gallery) {
	    	const settings = {
				dots: true,
				infinite: false,
				speed: 500,
				slidesToShow: 1,
				slidesToScroll: 1,
				beforeChange: (current, next) => this.setState({ slideIndex: next })
			};
			const slides = this.props.item.gallery.map((slide,i) =>
				{
					return (
						<div key={i} className={"u-fit-" + slide.fit}><ProductGalleryImage slide={slide}></ProductGalleryImage></div>
					)
				}
			);

			return (
				
				<>
					<div className="scope-slick">
						<Slider {...settings}>
							{slides}
						</Slider>
						<div className="slick-cover"></div>
					</div>
					<div className="c-product__gallery__caption">
						{this.props.item.gallery.map((slide,i) =>
							{
								if (i === this.state.slideIndex && slide.caption) {
									return (
										<p className="c-product__gallery__caption__text" dangerouslySetInnerHTML={ {__html: slide.caption } }></p>
									)
								} else {
									return null;
								}
							}
						)}
					</div>
				</>
			);
			
		} else {
			return null;
		}
	}
}